import { render, staticRenderFns } from "./module_add.vue?vue&type=template&id=608c87d1&scoped=true&"
import script from "./module_add.vue?vue&type=script&lang=js&"
export * from "./module_add.vue?vue&type=script&lang=js&"
import style0 from "./module_add.vue?vue&type=style&index=0&id=608c87d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608c87d1",
  null
  
)

export default component.exports